var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-query"},[_c('headImg'),_c('statisticsData',{attrs:{"headImgs":_vm.headImgs}}),_c('statisticsStudy'),_c('statisticsOther')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }